import GetHeroIcon from "@assessment/utils/getHeroIcons";
import { useEffect, useState } from "react";

interface HintPropType {
  hints: string[];
  visibleCount?: number;
}

const ShowHint = ({ hints, visibleCount = 0 }: HintPropType) => {
  const [localHints, setLocalHints] = useState<string[]>([]);

  useEffect(() => {
    setLocalHints(hints.slice(0, visibleCount));
  }, [visibleCount, hints]);

  return (
    <>
      {localHints.map((hint, index) => (
        <div
          key={index}
          className="p-4 bg-yellow-50 text-yellow-700 border border-yellow-200 rounded-lg  "
        >
          <div className="flex items-center space-x-2">
            <GetHeroIcon
              name="LightBulbIcon"
              className="w-6 h-6 dark:text-yellow-600"
              variant="outline"
            />
            <p
              dangerouslySetInnerHTML={{
                __html: `${hint}`
              }}
              // style={{ whiteSpace: "pre-line" }}
              style={{
                whiteSpace: "pre-wrap", // Allow wrapping and preserve newlines
                wordWrap: "break-word", // Ensure long words break
                wordBreak: "break-word", // Ensure long words break (for more robust wrapping)
                overflow: "hidden" // Prevent horizontal scrolling
              }}
            >
              {/* {hint} */}
            </p>
          </div>
        </div>
      ))}
    </>
  );
};

export default ShowHint;
